import { useState, useRef, useEffect } from 'react';
import { CSVLink } from "react-csv";

export default function ExportCsv({ table, originalData = [] }) {
	const [csvData, setCsvData] = useState([]);
	const [filename, setFilename] = useState("export.csv");
	const [dropdownOpen, setDropdownOpen] = useState(false);

	const headers = table.getHeaderGroups()[0].headers;
	const dropdownRef = useRef(null);


	const prepareData = (type, completeExport) => {
		const getWantedLabel = (wanted) => {
			switch (wanted) {
				case 1:
					return "Wanted";
				case 2:
					return "Priority";
				default:
					return "Unwanted";
			}
		};
		let rows;

		if (type === "filtered") {
			rows = table.getSortedRowModel().flatRows.map(row =>
				headers.map(h =>
					h.id === 'speciesStatus'
						? getWantedLabel(row.original.wanted)
						: row.getValue(h.id)
				)
			);
			setFilename("target_list.csv");
		} else {
			rows = originalData.map(row =>
				headers.map(h =>
					h.id === 'speciesStatus'
						? getWantedLabel(row.wanted )
						: row[h.id]
				)
			);
			setFilename("target_list_all_species.csv");
		}

		setCsvData([headers.map(h => h.id), ...rows]);
		setDropdownOpen(false);
		completeExport(true);
	};

	const toggleDropdown = () => {
		setDropdownOpen(prev => !prev);
	};

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setDropdownOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	return (
		<div className="dropdown export-dropdown" ref={dropdownRef}>
			<button
				className="btn-main export purple dropdown-toggle"
				type="button"
				onClick={toggleDropdown}
			>
				Export
			</button>

			<div className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`}>
				<CSVLink
					data={csvData}
					filename={filename}
					separator=";"
					asyncOnClick={true}
					onClick={(e, completeExport) => prepareData("filtered", completeExport)}
					className="dropdown-item"
				>
					Export Filtered
				</CSVLink>

				<CSVLink
					data={csvData}
					filename={filename}
					separator=";"
					asyncOnClick={true}
					onClick={(e, completeExport) => prepareData("all", completeExport)}
					className="dropdown-item"
				>
					Export All
				</CSVLink>
			</div>
		</div>
	);
}
